// Devuelve la fecha local en formato YYYY-MM-DD
export function getLocalDateString() {
  const date = new Date();
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Tijuana';

  const options = {
    timeZone: tz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour12: false
  };

  const formatter = new Intl.DateTimeFormat('sv-SE', options);
  return formatter.format(date); // Ej: "2025-08-02"
}

// Opcional: Devuelve la fecha y hora local en formato YYYY-MM-DD HH:mm:ss
export function getLocalDateTimeString() {
  const date = new Date();
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Tijuana';

  const options = {
    timeZone: tz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  };

  const formatter = new Intl.DateTimeFormat('sv-SE', options);
  const parts = formatter.formatToParts(date);
  const get = (type) => parts.find(p => p.type === type)?.value.padStart(2, '0');

  return `${get('year')}-${get('month')}-${get('day')} ${get('hour')}:${get('minute')}:${get('second')}`;
}

export function formatToLocalDate(dateInput, timeZone = 'America/Tijuana') {
  const date = new Date(dateInput);
  if (isNaN(date)) return null;

  const options = {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour12: false,
  };

  const formatter = new Intl.DateTimeFormat('sv-SE', options);
  return formatter.format(date); // YYYY-MM-DD
}

// Convierte string 'YYYY-MM-DD' en Date local sin desfase horario
export function getLocalDateObjectFromInput(input) {
  const [year, month, day] = input.split('-').map(Number);
  return new Date(year, month - 1, day); // mes es base 0
}

// Devuelve un objeto Date de la fecha local actual (sin desfase de zona horaria)
export function getLocalDateObject() {
  const localDateStr = getLocalDateString(); // 'YYYY-MM-DD'
  return getLocalDateObjectFromInput(localDateStr); // Date con 00:00 local
}

export function formatToLocalDateTime(dateInput, timeZone = 'America/Tijuana') {
  const date = new Date(dateInput);
  if (isNaN(date)) return null;
  const options = {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  };
  const formatter = new Intl.DateTimeFormat('sv-SE', options);
  const parts = formatter.formatToParts(date);
  const get = (type) => parts.find(p => p.type === type)?.value.padStart(2, '0');
  return `${get('year')}-${get('month')}-${get('day')} ${get('hour')}:${get('minute')}:${get('second')}`;
}

export function dateFormatDDMMAAAA(dateInput) {
  if (!dateInput) return null;

  let year, month, day;

  if (typeof dateInput === "string" && dateInput.includes("T")) {
    // ISO: 2025-02-12T08:00:00.000Z
    const [datePart] = dateInput.split("T");
    [year, month, day] = datePart.split("-").map(Number);
  } else if (typeof dateInput === "string") {
    // YYYY-MM-DD
    [year, month, day] = dateInput.split("-").map(Number);
  } else {
    return null;
  }

  const date = new Date(year, month - 1, day);

  if (isNaN(date.getTime())) return null;

  return date.toLocaleDateString("es-MX", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}
export function dateFormatNameComplete(dateInput, timeZone = "America/Tijuana") {
  if (!dateInput) return null;

  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return null;

  const formatted = date.toLocaleDateString('es-MX', {
    timeZone, // evita desfase según zona especificada
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })

  // opcional: reemplazar "/" por "-"
  return formatted;
}

export const toYMD = (d) => d.toISOString().slice(0, 10); // Tranforma objeto fecha en string aaaa/mm/dd

